export default __webpack_public_path__ + "static/media/time-line-active.a7147025.svg";